module.exports = __webpack_public_path__ + "static/img/user.98f7ba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.png
// module id = 8tHC
// module chunks = 1